import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4910b773"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bask" }
const _hoisted_2 = {
  key: 0,
  class: "adbox"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "baskname" }
const _hoisted_5 = { class: "baskname-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "baskname-right" }
const _hoisted_9 = { class: "baskname-right-senr" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Q1", -1 /* HOISTED */))
const _hoisted_11 = { class: "baskname-right-senr" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Q2", -1 /* HOISTED */))
const _hoisted_13 = { class: "baskname-right-senr" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Q3", -1 /* HOISTED */))
const _hoisted_15 = { class: "baskname-right-senr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Q4", -1 /* HOISTED */))
const _hoisted_17 = { class: "baskname-right-senr" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "QT", -1 /* HOISTED */))
const _hoisted_19 = { class: "baskname-right-senr" }
const _hoisted_20 = { class: "details" }
const _hoisted_21 = { class: "details-tab flexcenter" }
const _hoisted_22 = {
  key: 0,
  class: "basktext"
}
const _hoisted_23 = { class: "basktext-left" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basktext-left-xt" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */))
const _hoisted_25 = { class: "basktext-right" }
const _hoisted_26 = { class: "basktext-right-name" }
const _hoisted_27 = { class: "basktext-right-right" }
const _hoisted_28 = {
  key: 1,
  class: "backjshu"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "backjshu-top" }
const _hoisted_31 = { class: "backjshu-top-title" }
const _hoisted_32 = { class: "skname" }
const _hoisted_33 = { class: "skname-left" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_35 = { class: "skname-right" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_37 = { class: "backjshushy" }
const _hoisted_38 = { class: "backjshu-centent-left" }
const _hoisted_39 = { class: "backjshu-centent-box" }
const _hoisted_40 = { class: "backjshu-centent-right" }
const _hoisted_41 = { class: "backjshu-tongji" }
const _hoisted_42 = { class: "backjshu-tongji-title" }
const _hoisted_43 = {
  key: 0,
  class: "statistics-sen"
}
const _hoisted_44 = { class: "statistics-sen-top" }
const _hoisted_45 = { class: "statistics-sen-bottom flexcenter" }
const _hoisted_46 = { class: "statistics-sen-bottom-left" }
const _hoisted_47 = { class: "statistics-sen-bottom-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (($setup.matchAD && $setup.th != 'th'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "adimg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toLocationBrowser($setup.matchAD.url))),
            src: $setup.matchAD.img,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('play.team')), 1 /* TEXT */),
        _createElementVNode("p", null, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString($setup.team1), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString($setup.team2), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString($setup.home_score ? $setup.home_score[0] : ""), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.away_score ? $setup.away_score[0] : ""), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("p", null, _toDisplayString($setup.home_score ? $setup.home_score[1] : ""), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.away_score ? $setup.away_score[1] : ""), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", null, _toDisplayString($setup.home_score ? $setup.home_score[2] : ""), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.away_score ? $setup.away_score[2] : ""), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("p", null, _toDisplayString($setup.home_score ? $setup.home_score[3] : ""), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.away_score ? $setup.away_score[3] : ""), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("p", null, _toDisplayString($setup.home_score ? $setup.home_score[4] : ""), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.away_score ? $setup.away_score[4] : ""), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('play.zf')), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.allHomeScore), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.allAwayScore), 1 /* TEXT */)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.detailsshow = !$setup.detailsshow)),
            style: _normalizeStyle({
      color: $setup.detailsshow ? '#fff' : $setup.primaryColor,
      'background-color': $setup.detailsshow ? $setup.primaryColor : '#fff',
    })
          }, _toDisplayString(_ctx.$t('play.textLive')), 5 /* TEXT, STYLE */),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.detailsshow = !$setup.detailsshow)),
            style: _normalizeStyle({
      color: $setup.detailsshow ? $setup.primaryColor : '#fff',
      'background-color': !$setup.detailsshow ? $setup.primaryColor : '#fff',
    })
          }, _toDisplayString(_ctx.$t('play.tongji')), 5 /* TEXT, STYLE */)
        ])
      ]),
      ($setup.detailsshow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_van_collapse, {
              modelValue: $setup.basktextname,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.basktextname) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tlive, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_collapse_item, {
                    key: index,
                    title: item.title,
                    name: index + 1
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.live, (itemss, indexss) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "basktext-cen",
                          key: indexss
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("p", null, [
                              _createElementVNode("span", null, _toDisplayString($setup.getItemsData(itemss, 1)), 1 /* TEXT */)
                            ]),
                            _hoisted_24
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("p", null, _toDisplayString($setup.getItemsData(itemss, 5)), 1 /* TEXT */)
                            ]),
                            _createElementVNode("p", _hoisted_27, _toDisplayString($setup.getItemsData(itemss, 4)), 1 /* TEXT */)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "name"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            ($setup.incidents.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('play.gxzg')), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("p", null, _toDisplayString($setup.team1), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("p", null, _toDisplayString($setup.team2), 1 /* TEXT */),
                        _hoisted_36
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.incidents, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "backjshu-centent",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("p", null, _toDisplayString(item.homeName), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", null, _toDisplayString(item.homeScore), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString(item.awayScore), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("p", null, _toDisplayString(item.awayName), 1 /* TEXT */)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('play.teamTj')), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statsall, (item, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                  (item != '' && item != null && item != undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("span", null, _toDisplayString(item[1]), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString($setup.getType(item[0])), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString(item[2]), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("p", {
                              style: _normalizeStyle({ width: $setup.getPercent(item[2], item[1]) + '%', })
                            }, null, 4 /* STYLE */)
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("p", {
                              style: _normalizeStyle({ width: $setup.getPercent(item[1], item[2]) + '%', })
                            }, null, 4 /* STYLE */)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
    ])
  ]))
}